import { render, staticRenderFns } from "./Dozentenbuchungsliste.vue?vue&type=template&id=15b2fb09"
import script from "./Dozentenbuchungsliste.vue?vue&type=script&lang=js"
export * from "./Dozentenbuchungsliste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports